import { Stack } from "@mui/material";
import type { ProfileLookup } from "Api/Queries/Social/usePublicProfileQuery";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { ProfilePaper } from "Pages/PublicProfile/ProfilePaper";

type Props = {
  lookup: ProfileLookup;
};

/**
 * ANONYMOUS variant of the public profile page (ZS-1320): the bare, vertically
 * centered paper without any app chrome. Signed-in viewers get
 * AuthenticatedPublicProfilePage instead (see Routes/PublicProfileRoute).
 */
export const PublicProfilePage = ({ lookup }: Props) => (
  <StyledPageWrapper>
    <Stack
      className="left-content"
      height="100%"
      alignItems="center"
      justifyContent="center"
    >
      <ProfilePaper lookup={lookup} />
    </Stack>
  </StyledPageWrapper>
);

export default PublicProfilePage;
